import axios from "axios";

// export const baseUrl="http://localhost:5157/";
// export const baseUrl="https://ngr-mtn.kiddzmania.com/";
export const baseUrl="/";

export const getVideosApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/get-videos`);
    return response;
}

export const loginApi=async(msisdn)=>{
    const response=await axios.post(`${baseUrl}api/v1/login`,{
        msisdn:msisdn
    });
    return response;
}